import config from "@/config";
import http from "@/utils/request";

export default {
	requiredCourse: {
		list: {
			url: `${config.API_URL}/admin/user_level_required_course/getList`,
			name: "获取等级必修课列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/user_level_required_course/create`,
			name: "新增等级必修课",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/user_level_required_course/update`,
			name: "修改等级必修课",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/user_level_required_course/delete`,
			name: "删除等级必修课",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
	},
};
